/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { JobAction } from './JobAction';
import {
    JobActionFromJSON,
    JobActionFromJSONTyped,
    JobActionToJSON,
} from './JobAction';

/**
 * 
 * @export
 * @interface UpdateJobOccurrenceDto
 */
export interface UpdateJobOccurrenceDto {
    /**
     * 
     * @type {JobAction}
     * @memberof UpdateJobOccurrenceDto
     */
    action?: JobAction;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobOccurrenceDto
     */
    $type?: UpdateJobOccurrenceDtoTypeEnum;
}


/**
 * @export
 */
export const UpdateJobOccurrenceDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoUpdateJobOccurrenceDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateJobOccurrenceDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UpdateJobOccurrenceDtoTypeEnum = typeof UpdateJobOccurrenceDtoTypeEnum[keyof typeof UpdateJobOccurrenceDtoTypeEnum];


/**
 * Check if a given object implements the UpdateJobOccurrenceDto interface.
 */
export function instanceOfUpdateJobOccurrenceDto(value?: unknown): value is UpdateJobOccurrenceDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UpdateJobOccurrenceDtoTypeEnum)[0];
}

export function UpdateJobOccurrenceDtoFromJSON(json: any): UpdateJobOccurrenceDto {
    return UpdateJobOccurrenceDtoFromJSONTyped(json, false);
}

export function UpdateJobOccurrenceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateJobOccurrenceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': !exists(json, 'action') ? undefined : JobActionFromJSON(json['action']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function UpdateJobOccurrenceDtoToJSON(value?: UpdateJobOccurrenceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'action': JobActionToJSON(value.action),
        '$type': value.$type,
    });
}

